import React, { useEffect, useRef } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFrown } from "@fortawesome/free-regular-svg-icons";

import "./MetabaseDashboard.css";

const iconStyle = {
  color: "rgba(251, 154, 154, 0.987)",
  marginTop: "0.3em"
};

function MetabaseDashboard({
  url,
  title,
  className,
  iframeWidth,
  iframeHeight,
  iframeStyle,
  onLoad,
  isMetabaseOk,
  errorStyle
}) {
  const ref = useRef();

  useEffect(() => {
    // Ensure the iframe reference exists before trying to set attributes.
    if (ref.current) {
      ref.current.setAttribute("credentialless", "");
    }
  }, [ref]);
  return (
    <>
      {isMetabaseOk ? (
        <div className={"metabase-dashboard__container " + className}>
          <iframe
            style={iframeStyle}
            title={title}
            src={url}
            width={iframeWidth ?? "100%"}
            height={iframeHeight ?? "100%"}
            onLoad={onLoad}
            ref={ref}
          />
        </div>
      ) : (
        <div className="metabase-dashboard-error__container" style={errorStyle}>
          <div>
            <span className="metabase-dashboard-error__container-header">
              Sorry, something went wrong. Try refreshing the page.
            </span>
          </div>
          <FontAwesomeIcon icon={faFrown} size="5x" style={iconStyle} />
        </div>
      )}
    </>
  );
}

export default MetabaseDashboard;
